import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectModel } from '../../project/model/project/project.model';
import { environment } from './../../../environments/environment';
import { UserManagerService } from 'src/app/user-manager/service/user-manager.service';
import { NotifierService } from 'angular-notifier';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
@Injectable({
  providedIn: 'root'
})
export class ProjectDashboardService {
  appurl = '/v2/api/projects';
  CREATE_PROJECT = '/v2/api/projectCreate';
  UPDATE_PROJECT = '/v3/api/projectUpdate';
  DETAILS_PROJECT = '/v2/api/projectDetails';
  public teamList:any[] = [];
  public userList:any[] = [];
  public shareRepoUserList:any[] = [];
  public orgUserList:any[] = [];
  public orgTeamList:any[] = [];
  public selectedProject:any = {};
  // GET_ALL_ORGANIZATION = '/v2/api/organizations';
  GET_ALL_ORGANIZATION = '/v2/api/organizations';
  access = JSON.parse(localStorage.getItem('access'));
  studyInfo:any;
  httpPostOptions =
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
      };
  private apiRequestHttpOptions:any = {
    httpOptions:this.httpPostOptions
  };

  constructor(private http: HttpClient, private userManagerService:UserManagerService,
    private notifier: NotifierService, private apiRequest: ApiRequestService) { }
  getProjects() {
      this.studyInfo = {user_uuid: this.access.id};
      return this.apiRequest.request('POST',this.appurl,this.studyInfo,this.apiRequestHttpOptions)
    // return this.http.post<ProjectModel>(this.appurl, this.studyInfo ,this.httpPostOptions);
    // .pipe(
    //   retry(1),
    //   catchError(this.handleError)
    // );
  }
  getPaginationProject(pageData: any) {
    this.studyInfo = {user_uuid: this.access.id, pageNo: pageData['pageNo'], pageLimit: pageData['pageLimit'], filters: `{"projectType": ` + pageData['filters'] + `}`};
    return this.apiRequest.request('POST',this.appurl,this.studyInfo,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<ProjectModel>(this.appurl, this.studyInfo ,this.httpPostOptions);
  }
  createProject(data:any){
    return this.apiRequest.request('POST',this.CREATE_PROJECT,data,this.apiRequestHttpOptions)
    // return this.http.post<ProjectModel>(this.CREATE_PROJECT, data ,this.httpPostOptions);
  }

  updateProject(data:any){
    return this.apiRequest.request('POST',this.UPDATE_PROJECT,data,this.apiRequestHttpOptions)
    // return this.http.post<ProjectModel>(this.UPDATE_PROJECT, data ,this.httpPostOptions);
  }

  getAllOrganization(){
    return this.apiRequest.request('GET',this.GET_ALL_ORGANIZATION,{},this.apiRequestHttpOptions)
    // return this.http.get<ProjectModel>(this.GET_ALL_ORGANIZATION ,this.httpPostOptions);
  }

  getProjectDetails(data:any){
    return this.apiRequest.request('POST',this.DETAILS_PROJECT,data,this.apiRequestHttpOptions)
    // return this.http.post<ProjectModel>(this.DETAILS_PROJECT, data ,this.httpPostOptions);
  }

  getAProjectDetails(uuid){
    let body = {"uuid":uuid}
    // console.log("body is ",body)
    this.getProjectDetails(body)
    .subscribe(result =>{
      if (result['status'] == 1) {
        this.selectedProject = result['project'];
        this.selectedProject['ulist'] = this.selectedProject['userList'].map(item => item.uuid);
        this.selectedProject['tlist'] = this.selectedProject['teamList'].map(item => item.uuid);
        this.selectedProject['srulist'] = this.selectedProject['shareRepoList'].map(item => item.uuid) || [];
        this.selectedProject['oldTlist'] = this.selectedProject['teamList'].map(item => item.uuid);
        this.filterSelectedUserFirst();
        this.getTeamList({"org_uuid":this.selectedProject.org_uuid});
        this.getUsers({"org_uuid":this.selectedProject.org_uuid,"isOrgUser":true,"status":1});
      }
    })
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
  
  getTeamList(query){
    this.userManagerService.getTeamList(query).subscribe(
      result =>{
        if (result['status'] == 1) {
          this.teamList = result['team'];
          this.orgTeamList = result['team'];
        }else{
          this.notifier.notify('error','Something went wrong.');
      }
      }
    )
  }

  getUsers(query){
    this.userManagerService.getUserList(query,'updateProject').subscribe(responce => {
        if(responce['status'] == 1){
            this.orgUserList = responce['users'];
            this.userList = responce['users'];
            this.shareRepoUserList = responce['users'];
            this.filterSelectedUserFirst();
        }else{
            this.notifier.notify('error','Something went wrong.');
        }
        // this.userManagerService.isLoading = false;
    }, error => {
        if(error){
            this.notifier.notify('error','User is not authorised.');
        }else{
            this.notifier.notify('error','Something went wrong.');
        }
        // this.userManagerService.isLoading = false;
    })
}

filterSelectedUserFirst(){
  if (this.userList && this.userList.length && this.selectedProject && this.selectedProject['ulist'] && this.selectedProject['ulist'].length) {
    this.userList.sort((a,b) => this.selectedProject['ulist'].indexOf(a.uuid) >= 0 ?-1:1);
    // console.log("this.userList ===>",this.userList)
  }
}

filterSelectedShareRepoUserFirst(){
  if (this.shareRepoUserList && this.shareRepoUserList.length && this.selectedProject && this.selectedProject['ulist'] && this.selectedProject['ulist'].length) {
    this.shareRepoUserList.sort((a,b) => this.selectedProject['ulist'].indexOf(a.uuid) >= 0 ?-1:1);
    // console.log("this.userList ===>",this.userList)
  }
}

filterByKey(dataList,key,value,selectedValue){
  // return dataList.filter(item =>{ return item[key].toLowerCase().includes(value.toLowerCase()) || selectedValue.includes(item['uuid'])})
  let filterList = dataList.filter(item =>{ return item[key].toLowerCase().includes(value.toLowerCase())})
  let selectedList = dataList.filter(item =>{ return selectedValue.includes(item['uuid'])})
  return [...filterList,...selectedList]
}

}

